export interface ComicCategory {
  slug: string;
  name: string;
  description: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  order: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updatedAt: string;
  chapters: ComicChapter[];
  totalChapters: number;
}

export interface Review {
  id: string;
  username: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const categories: ComicCategory[] = [
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的韩漫恋爱故事' },
  { slug: 'fantasy', name: '奇幻', description: '充满想象力的奇幻世界' },
  { slug: 'action', name: '热血', description: '燃爆肾上腺素的热血战斗' },
  { slug: 'drama', name: '剧情', description: '扣人心弦的精彩剧情' },
  { slug: 'comedy', name: '搞笑', description: '让你捧腹大笑的欢乐漫画' },
  { slug: 'thriller', name: '悬疑', description: '紧张刺激的悬疑推理' },
  { slug: 'school', name: '校园', description: '青春洋溢的校园生活' },
  { slug: 'office', name: '职场', description: '职场奋斗与成长故事' },
];

export const comics: Comic[] = [
  {
    id: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '金作家',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20standing%20inside%20a%20cozy%20vintage%20general%20store%20filled%20with%20antiques%20and%20mysterious%20items%2C%20warm%20ambient%20lighting%2C%20soft%20watercolor%20texture%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20detailed%20background%2C%20emotional%20expression&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '在首尔一条安静的小巷里，有一家名为"洞洞杂货铺"的古老店铺。店主是一位神秘的年轻女子，她出售的每件物品都承载着一段不为人知的故事。当顾客走进这家店铺，他们的人生将因这些充满魔力的物品而发生改变。这是一部关于爱与治愈、命运与选择的温暖韩漫。',
    category: 'romance',
    tags: ['治愈', '奇幻', '恋爱', '日常'],
    status: '连载中',
    rating: 4.8,
    views: 1850000,
    favorites: 320000,
    updatedAt: '2026-08-05',
    totalChapters: 86,
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `ch-${i + 1}`,
      title: `第${i + 1}话 ${['命运的相遇', '神秘的礼物', '回忆的香气', '错过的时光', '温暖的守护', '星光下的约定', '未完的旋律', '重逢的季节', '心底的秘密', '绽放的花朵'][i % 10]}`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((86 - i) / 4))).padStart(2, '0')}-${String((i * 7 + 5) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'xingkong-wangzi',
    title: '星空下的王子',
    author: '李美娜',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20art%20featuring%20a%20handsome%20prince%20character%20standing%20under%20a%20starry%20night%20sky%2C%20with%20flowing%20royal%20robes%2C%20soft%20dreamy%20lighting%2C%20romantic%20fantasy%20atmosphere%2C%20delicate%20linework%2C%20pastel%20color%20palette%2C%20Korean%20webtoon%20style&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '平凡的女高中生林小月在一次流星雨之夜意外穿越到了异世界，成为了被诅咒王国的最后一个希望。在这里，她遇到了被封印在星空城堡中的神秘王子。两人携手对抗黑暗势力，在星光璀璨的冒险中，一段跨越时空的浪漫爱情悄然绽放。',
    category: 'fantasy',
    tags: ['穿越', '爱情', '奇幻', '冒险'],
    status: '已完结',
    rating: 4.9,
    views: 2450000,
    favorites: 520000,
    updatedAt: '2026-07-28',
    totalChapters: 120,
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `ch-xk-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((120 - i) / 5))).padStart(2, '0')}-${String((i * 3 + 10) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'milian-biji',
    title: '秘密恋爱笔记',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20manhwa%20cover%20showing%20two%20high%20school%20students%2C%20a%20boy%20and%20girl%2C%20sharing%20earbuds%20while%20sitting%20on%20a%20rooftop%20at%20sunset%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20golden%20light%2C%20youthful%20and%20nostalgic%20mood%2C%20clean%20art%20style&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '学霸班长和校园人气王意外成为了同桌，两人约定用一本秘密笔记记录彼此的恋爱攻略。然而在帮助对方追求心上人的过程中，他们发现自己真正喜欢的人竟然是对方。一部甜到爆炸的校园恋爱韩漫，让你重温青春的心动。',
    category: 'school',
    tags: ['校园', '恋爱', '甜宠', '日常'],
    status: '连载中',
    rating: 4.7,
    views: 1680000,
    favorites: 280000,
    updatedAt: '2026-08-04',
    totalChapters: 64,
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `ch-ml-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((64 - i) / 4))).padStart(2, '0')}-${String((i * 5 + 3) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'juezhan-zhi-dian',
    title: '决战之巅',
    author: '郑勇俊',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20action%20Korean%20manhwa%20cover%20featuring%20a%20fierce%20martial%20artist%20in%20dynamic%20fighting%20pose%2C%20energy%20bursts%20and%20speed%20lines%2C%20dramatic%20lighting%20with%20red%20and%20orange%20tones%2C%20intense%20expression%2C%20powerful%20composition%2C%20Korean%20webtoon%20action%20style&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '在武道为尊的世界里，少年陈烈从一个被人看不起的废柴，通过不懈努力和奇遇，一步步登上武道巅峰。热血沸腾的战斗场面，扣人心弦的成长历程，这是一部让你燃到爆炸的韩式热血漫画。',
    category: 'action',
    tags: ['热血', '战斗', '成长', '武侠'],
    status: '连载中',
    rating: 4.6,
    views: 2100000,
    favorites: 450000,
    updatedAt: '2026-08-03',
    totalChapters: 98,
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-jz-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((98 - i) / 4))).padStart(2, '0')}-${String((i * 6 + 7) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'shikong-lvxingzhe',
    title: '时空旅行者',
    author: '尹素熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20cover%20with%20a%20time%20traveler%20standing%20between%20two%20different%20eras%2C%20one%20side%20ancient%20Korea%20with%20hanbok%2C%20other%20side%20modern%20city%2C%20clock%20gears%20and%20time%20portals%2C%20dreamy%20atmospheric%20lighting%2C%20intricate%20details%2C%20fantasy%20drama%20style&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '拥有穿越时空能力的少女素熙，每次入睡都会随机穿越到不同的历史时代。在一次意外中，她发现自己的穿越能力与一个古老的家族秘密有关。为了解开谜团，她必须在各个时空中寻找线索，同时还要面对那些因时空错乱而出现的危险。',
    category: 'drama',
    tags: ['穿越', '悬疑', '剧情', '奇幻'],
    status: '已完结',
    rating: 4.8,
    views: 1320000,
    favorites: 310000,
    updatedAt: '2026-06-15',
    totalChapters: 78,
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: `ch-sk-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((78 - i) / 5))).padStart(2, '0')}-${String((i * 4 + 12) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'gaoxiao-richang',
    title: '搞笑日常手册',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20colorful%20Korean%20comedy%20manhwa%20cover%20showing%20exaggerated%20funny%20facial%20expressions%20of%20multiple%20characters%20in%20everyday%20situations%2C%20bright%20cheerful%20colors%2C%20cartoonish%20and%20playful%20art%20style%2C%20Korean%20webtoon%20comedy%20genre&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '四个性格迥异的室友住在一起，每天都上演着令人捧腹的搞笑日常。从做饭翻车到网购踩雷，从职场囧事到恋爱乌龙，这部漫画以轻松幽默的方式展现了当代年轻人的生活百态，让你笑到停不下来。',
    category: 'comedy',
    tags: ['搞笑', '日常', '生活', '友情'],
    status: '连载中',
    rating: 4.5,
    views: 980000,
    favorites: 180000,
    updatedAt: '2026-08-04',
    totalChapters: 52,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch-gx-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((52 - i) / 4))).padStart(2, '0')}-${String((i * 7 + 2) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'heiye-zhuizong',
    title: '黑夜追踪',
    author: '崔敏浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20suspenseful%20Korean%20thriller%20manhwa%20cover%20with%20a%20detective%20holding%20a%20flashlight%20in%20a%20dark%20alley%2C%20rain%20and%20shadows%2C%20mysterious%20silhouette%20in%20distance%2C%20noir%20atmosphere%2C%20cinematic%20lighting%2C%20tense%20mood%2C%20Korean%20webtoon%20thriller%20style&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '刑警韩东秀接手了一桩连环失踪案，所有失踪者最后的行踪都指向一个已废弃多年的精神病院。随着调查深入，他发现案件背后隐藏着一个令人毛骨悚然的真相。每一步都可能是陷阱，每一个人都可能是凶手。这部悬疑韩漫将带你进入一场惊心动魄的推理之旅。',
    category: 'thriller',
    tags: ['悬疑', '推理', '犯罪', '惊悚'],
    status: '连载中',
    rating: 4.7,
    views: 1560000,
    favorites: 290000,
    updatedAt: '2026-08-02',
    totalChapters: 42,
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-hy-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((42 - i) / 4))).padStart(2, '0')}-${String((i * 8 + 1) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'zongcai-mi-mi',
    title: '总裁的秘密',
    author: '宋慧乔',
    cover: 'https://readdy.ai/api/search-image?query=An%20elegant%20Korean%20office%20romance%20manhwa%20cover%20featuring%20a%20handsome%20CEO%20in%20a%20luxurious%20office%20with%20a%20female%20employee%2C%20city%20skyline%20through%20floor%20to%20ceiling%20windows%2C%20professional%20yet%20romantic%20atmosphere%2C%20sophisticated%20color%20palette%2C%20clean%20modern%20art%20style&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '职场新人金多喜入职第一天就发现自己直属上司是高中时暗恋过的学长。现在的他已是商界叱咤风云的年轻总裁，却隐藏着一个不为人知的秘密。当办公室恋情开始萌芽，过去的真相也慢慢浮出水面。一部职场与爱情交织的精致韩漫。',
    category: 'office',
    tags: ['职场', '恋爱', '总裁', '都市'],
    status: '已完结',
    rating: 4.6,
    views: 1980000,
    favorites: 380000,
    updatedAt: '2026-07-20',
    totalChapters: 96,
    chapters: Array.from({ length: 96 }, (_, i) => ({
      id: `ch-zc-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((96 - i) / 5))).padStart(2, '0')}-${String((i * 3 + 15) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'mofa-shaonv',
    title: '魔法少女的契约',
    author: '张美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20girl%20Korean%20manhwa%20cover%20with%20a%20girl%20in%20beautiful%20magical%20transformation%20costume%2C%20sparkling%20magic%20effects%2C%20floating%20crystals%20and%20stars%2C%20dreamy%20pastel%20colors%2C%20whimsical%20fantasy%20atmosphere%2C%20shojo%20style%20influenced%20Korean%20webtoon&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '普通中学生柳夏恩无意中与一只会说话的魔法猫签订了契约，获得了变身魔法少女的能力。但这份力量并非免费的礼物——每使用一次魔法，就会消耗一段珍贵的记忆。当面临保护世界和保留记忆的抉择时，夏恩必须做出最艰难的决定。',
    category: 'fantasy',
    tags: ['魔法', '少女', '奇幻', '成长'],
    status: '连载中',
    rating: 4.5,
    views: 1120000,
    favorites: 210000,
    updatedAt: '2026-08-01',
    totalChapters: 58,
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: `ch-mf-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((58 - i) / 4))).padStart(2, '0')}-${String((i * 5 + 9) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'chuntian-lai-le',
    title: '春天来了',
    author: '韩智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20spring%20themed%20Korean%20school%20romance%20manhwa%20cover%2C%20two%20students%20walking%20under%20cherry%20blossom%20trees%20on%20a%20school%20path%2C%20falling%20pink%20petals%2C%20warm%20sunlight%2C%20youthful%20and%20fresh%20atmosphere%2C%20delicate%20artwork%2C%20romantic%20mood&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '转学生林恩浩在樱花盛开的春天来到了新的学校。他沉默寡言的外表下藏着一颗温暖的心，而活泼开朗的同桌孙艺琳则慢慢打开了他的心扉。两个完全不同的灵魂在春天相遇，一段青涩而美好的校园恋情就此开始。',
    category: 'school',
    tags: ['校园', '恋爱', '青春', '治愈'],
    status: '已完结',
    rating: 4.8,
    views: 1750000,
    favorites: 350000,
    updatedAt: '2026-05-30',
    totalChapters: 68,
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: `ch-ct-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((68 - i) / 5))).padStart(2, '0')}-${String((i * 6 + 4) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'jianshen-fengbao',
    title: '健身风暴',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=A%20motivational%20Korean%20action%20comedy%20manhwa%20cover%20showing%20a%20transformed%20muscular%20character%20in%20a%20gym%20setting%2C%20dramatic%20before%20and%20after%20comparison%2C%20energetic%20vibe%2C%20dynamic%20posing%2C%20warm%20lighting%2C%20Korean%20webtoon%20style%20with%20bold%20lines&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '肥胖自卑的上班族在健身房邂逅了一位美貌女教练后，下定决心改变自己。从最初连一个俯卧撑都做不了，到后来成为健身达人，他的蜕变之路充满了汗水、泪水，当然也有很多笑料。这是一部励志又搞笑的韩漫佳作。',
    category: 'comedy',
    tags: ['搞笑', '励志', '健身', '生活'],
    status: '连载中',
    rating: 4.4,
    views: 890000,
    favorites: 150000,
    updatedAt: '2026-08-04',
    totalChapters: 45,
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch-js-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((45 - i) / 4))).padStart(2, '0')}-${String((i * 7 + 11) % 28 + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 'shenmi-shudian',
    title: '神秘书店',
    author: '金作家',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20Korean%20drama%20manhwa%20cover%20showing%20a%20vintage%20bookstore%20interior%20with%20towering%20bookshelves%2C%20a%20woman%20reading%20an%20old%20book%20under%20warm%20lamp%20light%2C%20dust%20particles%20floating%20in%20sunbeams%2C%20magical%20realism%20vibe%2C%20cozy%20yet%20mysterious%20mood&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '在一座古老城市的一角，有一家只在雨天营业的神秘书店。书店里的每一本书都记载着一个真实发生过的人生故事。当迷茫的人们走进这家书店，他们会在书中找到指引自己前行的答案。一部充满诗意与哲理的剧情韩漫。',
    category: 'drama',
    tags: ['剧情', '治愈', '人生', '哲理'],
    status: '连载中',
    rating: 4.9,
    views: 1450000,
    favorites: 340000,
    updatedAt: '2026-08-05',
    totalChapters: 36,
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `ch-sm-${i + 1}`,
      title: `第${i + 1}话`,
      order: i + 1,
      updatedAt: `2026-${String(Math.max(1, Math.ceil((36 - i) / 4))).padStart(2, '0')}-${String((i * 9 + 6) % 28 + 1).padStart(2, '0')}`,
    })),
  },
];

export const reviews: Review[] = [
  { id: 'r1', username: '漫画迷小王', avatar: '', rating: 5, content: '洞洞杂货铺太好看了！每话都让我感动得不行，画风也超级精美，强烈推荐给喜欢治愈系韩漫的朋友！', date: '2026-08-01' },
  { id: 'r2', username: '星空下的约定', avatar: '', rating: 5, content: '从第一话追到现在，洞洞杂货铺的剧情设计太巧妙了。每个物品背后的故事都让人深思，作者真的是天才！', date: '2026-07-28' },
  { id: 'r3', username: '韩漫爱好者', avatar: '', rating: 5, content: '51漫画网真的是我找到的最好的韩漫平台，更新快画质好，而且还是免费的！洞洞杂货铺在这里追太幸福了', date: '2026-07-25' },
  { id: 'r4', username: '读书少女', avatar: '', rating: 4, content: '神秘书店这部漫画的意境太美了，每一话都像在读一首散文诗。虽然不是传统的快节奏漫画，但细品真的很有味道。', date: '2026-07-22' },
  { id: 'r5', username: '热血青年', avatar: '', rating: 5, content: '决战之巅燃爆了！战斗分镜无敌，每一场对决都让人热血沸腾。追了快两年了，质量一直在线！', date: '2026-07-20' },
  { id: 'r6', username: '甜甜圈', avatar: '', rating: 5, content: '秘密恋爱笔记甜到炸裂！男女主互动太有爱了，每次更新都第一时间来看，根本停不下来～', date: '2026-07-18' },
  { id: 'r7', username: '推理达人', avatar: '', rating: 5, content: '黑夜追踪的悬疑氛围营造得太好了，每话结尾都有反转，猜不到接下来的剧情。韩漫悬疑题材的天花板！', date: '2026-07-15' },
  { id: 'r8', username: '樱花飘落', avatar: '', rating: 4, content: '春天来了让我想起了自己的学生时代，那种青涩的暗恋感觉描绘得太真实了。已经完结了但是回味无穷。', date: '2026-07-12' },
];

export const bannerSlides = [
  {
    id: 'b1',
    comicId: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    subtitle: '热门韩漫 · 治愈系巅峰之作',
    description: '一家神秘的杂货铺，每件物品都承载着不为人知的温暖故事',
    cover: 'https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20banner%20featuring%20a%20cozy%20mysterious%20vintage%20general%20store%20interior%20with%20warm%20golden%20lighting%2C%20antique%20items%20on%20wooden%20shelves%2C%20a%20beautiful%20young%20woman%20storekeeper%20in%20Korean%20manhwa%20art%20style%2C%20dust%20motes%20dancing%20in%20sunlight%2C%20dreamy%20atmosphere&width=1200&height=500&seq=banner-01&orientation=landscape',
  },
  {
    id: 'b2',
    comicId: 'xingkong-wangzi',
    title: '星空下的王子',
    subtitle: '完结佳作 · 评分4.9',
    description: '跨越时空的浪漫爱情，在星光下绽放的奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=A%20magnificent%20fantasy%20banner%20with%20a%20handsome%20prince%20character%20and%20a%20girl%20standing%20on%20a%20castle%20balcony%20under%20a%20breathtaking%20starry%20sky%2C%20swirling%20galaxy%20and%20constellations%2C%20royal%20palace%20in%20background%2C%20romantic%20fantasy%20mood%2C%20Korean%20manhwa%20art%20style&width=1200&height=500&seq=banner-02&orientation=landscape',
  },
  {
    id: 'b3',
    comicId: 'juezhan-zhi-dian',
    title: '决战之巅',
    subtitle: '热血连载 · 燃爆全场',
    description: '废柴少年逆天改命，登顶武道巅峰的传奇之路',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20martial%20arts%20banner%20with%20a%20powerful%20fighter%20surrounded%20by%20fiery%20energy%20auras%20on%20a%20mountain%20peak%2C%20dramatic%20sunset%20sky%2C%20dynamic%20action%20composition%2C%20intense%20red%20and%20orange%20color%20scheme%2C%20Korean%20manhwa%20action%20style&width=1200&height=500&seq=banner-03&orientation=landscape',
  },
];

export const siteInfo = {
  name: '51漫画网',
  fullName: '51漫画网 - 洞洞杂货铺韩漫全集免费阅读',
  description: '51漫画网致力于为广大韩漫爱好者提供最新、最全、最高清的韩漫全集免费阅读服务。我们收录了包括《洞洞杂货铺》在内的数百部优质韩漫作品，涵盖恋爱、奇幻、热血、悬疑等多种类型，每日更新，让您畅享韩漫魅力。',
  founded: '2020年',
  email: 'contact@ytzshn.cn',
  qq: '1234567890',
  wechat: 'manhua51',
  address: '北京市朝阳区漫画大厦',
  stats: {
    totalComics: 500,
    totalChapters: 50000,
    totalUsers: 5000000,
    dailyUpdate: 200,
  },
};

export const faqs = [
  { question: '51漫画网的漫画都是免费的吗？', answer: '是的，51漫画网所有漫画内容均提供免费阅读。我们致力于为广大韩漫爱好者打造一个优质、免费的漫画阅读平台，无需付费即可畅享全部漫画内容。' },
  { question: '洞洞杂货铺多久更新一次？', answer: '《洞洞杂货铺》通常在每周五更新一话。如遇特殊情况延迟更新，我们会在网站首页发布公告通知大家。' },
  { question: '如何找到自己想看的漫画？', answer: '您可以通过首页的分类导航、搜索功能，或者浏览"热门推荐"和"最新更新"板块来发现感兴趣的漫画。每个分类页面也提供了该类型下的全部漫画列表。' },
  { question: '51漫画网支持手机阅读吗？', answer: '当然支持！51漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备，无论您使用什么设备，都能获得流畅舒适的阅读体验。' },
  { question: '漫画图片加载不出来怎么办？', answer: '如果遇到图片加载问题，建议您先检查网络连接，或尝试刷新页面。如问题持续存在，可以联系我们客服获取帮助。' },
  { question: '可以下载漫画离线观看吗？', answer: '目前51漫画网提供在线免费阅读服务。出于版权保护考虑，暂不支持漫画下载功能，请您在线享受阅读乐趣。' },
];